import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Bandeira } from 'src/app/admihair/api/dto/bandeira';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { MeioPagamentoTributario } from 'src/app/admihair/api/dto/meio-pagamento-tributario';
import { Operacao } from 'src/app/admihair/api/dto/operacao';
import { ParcelaPagamento } from 'src/app/admihair/api/dto/parcela-pagamento';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { BandeiraService } from 'src/app/admihair/service/bandeira.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MeioPagamentoTributarioService } from 'src/app/admihair/service/meio-pagamento-tributario.service';
import { OperacaoFinanceiraService } from 'src/app/admihair/service/operacao-financeira.service';
import { ParcelaPagamentoService } from 'src/app/admihair/service/parcela-pagamento.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-tipo-pagamento-inserir',
  templateUrl: './tipo-pagamento-inserir.component.html',
  styleUrls: ['./tipo-pagamento-inserir.component.scss']
})
export class TipoPagamentoInserirComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  permissaoInserir: boolean = false;
  messages: Message[] = [];
  empresaSelecionada?: Empresa;
  messagemVisivel: boolean = false;
  tipoPagamento: TipoPagamento = { antecipacao: 0};
  operacoes: SelectItem[] = [];
  transacoes: string[] = ['AJUSTE', 'A VISTA', 'DEBITO', 'CREDITO'];
  bandeiras: string[] = [];
  parcelas: ParcelaPagamento[] = [];
  qtdParcelas: number = 1;
  progressoRequisicao: boolean = false;

  meiosPagamento: MeioPagamentoTributario[] = [];

  constructor(private tipoPagamentoService: TipoPagamentoService,
    private meioPagamentoTributarioService: MeioPagamentoTributarioService,
    private operacaoService: OperacaoFinanceiraService,
    private bandeiraService: BandeiraService,
    private parcelaPagamentoService: ParcelaPagamentoService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_TIPO_DE_PAGAMENTO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.buscarOperacoes();
      this.listarBandeiras();
      this.listarMeiosPagamento();
    }
  }

  buscarOperacoes(){
    this.operacaoService.listarPorEmpresaESituacao(this.empresaSelecionada?.id, true).subscribe({
      next: (data: Operacao[]) => {
        this.operacoes = data.map(item =>
           ({label: `${item.descricao} - ${item.conta?.descricao}`, value: item})
          );
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
        this.rolarTela();
      }
    });
  }

  listarBandeiras(){
    this.bandeiraService.listar().subscribe({
      next: (data: Bandeira[]) => {
        this.bandeiras = data.map(bandeira => bandeira.descricaoBandeira);
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
        this.rolarTela();
      }
    });
  }

  listarMeiosPagamento() {
    this.meioPagamentoTributarioService.listarAplicaveis().subscribe({
      next: (data: MeioPagamentoTributario[]) => {
        this.meiosPagamento = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  salvar(){
    this.progressoRequisicao = true;
    this.tipoPagamento.empresaId = this.empresaSelecionada?.id;
    this.tipoPagamento.descricao = this.formatarDescricao(this.tipoPagamento);
    this.tipoPagamento.antecipacao ?? 0;
    
    this.tipoPagamentoService.salvar(this.tipoPagamento).subscribe({
      next: (data: TipoPagamento) => {
        this.salvarParcelas(data);
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
          this.rolarTela();
      }
    });

  }

  salvarParcelas(tipoPagamento: TipoPagamento){
    for(let parcela of this.parcelas){
      parcela.tipoPagamento = tipoPagamento;
      if(!parcela.prazo){
        parcela.prazo = 0;
      }
      parcela.descontoFinanceira ?? 0;
      this.parcelaPagamentoService.salvar(parcela).subscribe({
        next: (data: ParcelaPagamento) => {
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
          this.rolarTela();
        }
      });
    }
  }

  exibirMensagemErro(err: any) {
    this.messages = this.erroService.handleErro(err);
    this.messagemVisivel = true;
  }

  formatarDescricao(tipo: TipoPagamento): string {
    return `${tipo.bandeira} ${tipo.transacao} ${tipo.operacao?.descricao}`;
  }

  gerarParcelas(){
    const inicioParcelas = this.parcelas.length === 0 ?
      1 : this.parcelas.length + 1;
    for(let i= inicioParcelas; i < inicioParcelas + this.qtdParcelas; i++){
      this.parcelas.push(
        { quantidadeParcelas: i,
          prazo: i * 30,
          descontoFinanceira: 0,
          status: true }
        );
    }
    this.qtdParcelas = 0;
    
  }

  excluirParcela(parcela: ParcelaPagamento){
    const posicao = this.parcelas.indexOf(parcela);
    this.parcelas.splice(posicao, 1);
  }
  
  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  limparFormulario(){
    this.form?.reset(); 
  }
  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  
  ocultarMsg(){
    this.messagemVisivel = false;
  }

  exibir(){
    console.log(this.tipoPagamento.antecipacao! / 100)
  }

}
